import { useCallback } from 'react';
import { getNodeAttributes } from '@tiptap/core';
import { ToolbarDivider } from 'modules/common/components/Toolbar/ToolbarDivider';
import { getTableData } from '../TableWidget.helpers';
import { ToolbarProps } from './TableWidgetToolbar.types';
import { HeaderOption } from './HeaderOption';
import { BorderColor } from './Color';
import { BorderWidth } from './BorderWidth';

export const ActiveToolbar = ({ editor, dispatchUpdateWidget }: ToolbarProps) => {
  const cellAttributes = editor.state && getNodeAttributes(editor.state, 'tableCell');
  const headerAttributes = editor.state && getNodeAttributes(editor.state, 'tableHeader');

  const cellBorderColor = cellAttributes?.borderColor;
  const headerBorderColor = headerAttributes?.borderColor;
  const cellBorderWidth = cellAttributes?.borderWidth;
  const headerBorderWidth = headerAttributes?.borderWidth;

  const onSetBorderColor = useCallback(
    (color: string) => {
      const { cellPositions } = getTableData(editor.view.state.doc);
      editor
        .chain()
        .setCellSelection({ anchorCell: cellPositions[0], headCell: cellPositions[cellPositions.length - 1] })
        .setCellAttribute('borderColor', color)
        .updateAttributes('tableHeader', { borderColor: color })
        .run();
      dispatchUpdateWidget();
    },
    [editor, dispatchUpdateWidget],
  );

  const onSetBorderWidth = useCallback(
    (width: string) => {
      const { cellPositions } = getTableData(editor.view.state.doc);
      editor
        .chain()
        .setCellSelection({ anchorCell: cellPositions[0], headCell: cellPositions[cellPositions.length - 1] })
        .setCellAttribute('borderWidth', width)
        .updateAttributes('tableHeader', { borderWidth: width })
        .run();
      dispatchUpdateWidget();
    },
    [editor, dispatchUpdateWidget],
  );

  const borderColor = (cellBorderColor || headerBorderColor) ?? '';
  const borderWidth = (cellBorderWidth || headerBorderWidth) ?? '';

  return (
    <>
      <BorderColor color={borderColor} onChange={onSetBorderColor} />
      <BorderWidth value={borderWidth} onChange={onSetBorderWidth} />
      <ToolbarDivider />
      <HeaderOption editor={editor} onChange={dispatchUpdateWidget} />
    </>
  );
};
